
import './MahutiModal.css';


export default function MahutiModal(props) {
    const handleClickExist = props.setModalOpen.bind(this);
    const customFN = props.customFN
    const closeModalWhenClickingBg = props.closeModalWhenClickingBg

    return <div className='mahutiModal bg' onClick={() => {handleClickExist(!closeModalWhenClickingBg); customFN && customFN()}} >
            <div onClick={(e) => e.stopPropagation()} className='inline-modal'>
                {props.children}
            </div>
        </div>

}